
import respUtility from '~/mixins/respUtility';
import routeMixin from '~/mixins/routeMixin';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('listing');

export default {
  name: 'ListingProductsNavigation',
  mixins: [respUtility, routeMixin],
  props: {
    itemsCount: {
      type: Number,
      default: 0,
    },
    searchParams: {
      type: Object,
      default() { return {}; },
    },
    pages: {
      type: Number,
      default: 1,
    },
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 36,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      perPageVariants: [
        { text: '36', value: 'PER_PAGE_36' },
        { text: '48', value: 'PER_PAGE_48' },
        { text: '72', value: 'PER_PAGE_72' },
      ],
    };
  },
  computed: {
    ...mapState(['currentSelected']),
    selectPerPage() {
      return this.perPageVariants.find((v) => v.value === this.searchParams.perPage)
        || this.perPageVariants[0];
    },
    totalVisible() {
      return !(this.$device.isMobileOrTablet || this.isTouchDevice) ? 6 : 5;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    currentPage: {
      get() {
        return Number(this.searchParams.page) || 1;
      },
      async set(newPage) {
        if (newPage === this.searchParams.page) {
          return;
        }
        await this.handleScroll();
        this.changeRouteFacets(this.currentSelected, '', newPage);
      },
    },
  },
  watch: {
    loading(status) {
      this.$emit('rerender', status);
    },
  },
  methods: {
    scrollIntoViewAndWait(element) {
      return new Promise((resolve) => {
        if ('onscrollend' in window) {
          document.addEventListener('scrollend', resolve, { once: true });
          element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        } else {
          element.scrollIntoView({ block: 'start', inline: 'start' });
          resolve();
        }
      });
    },
    async handleScroll() {
      const el = document.querySelector('#listing-products');
      if (!el) {
        return;
      }
      await this.scrollIntoViewAndWait(el);
    },
    async changePerPage(select) {
      if (select.value === this.selectPerPage.value) {
        return;
      }
      const pages = Math.ceil((this.pages * this.perPage) / (Number(select.text) || 36));
      const query = {
        ...this.$route.query,
        'per-page': select.value.toLowerCase(),
        page: pages >= this.page ? this.page : 1,
      };
      await this.handleScroll();
      this.$router.push({
        ...this.$route,
        query,
      });
    },
  },
};
